import Tr from 'translations/Translations';

const createItem = (label, value,disabled=false) => ({label, value, disabled})

export const VALUES = {
	NEW: 0,
}

export default [
	createItem(Tr('new'), VALUES.NEW),
]